import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';

export const useNewTopUpDesignSplitTest = () => {
    const splitTestBranch = useSplitTestBranch({
        test: 'new_topup_design',
        suspense: true
    }) as 'INCLUDE' | 'EXCLUDE' | undefined;

    return {
        branch: splitTestBranch
    };
};
